import { useSyncExternalStore } from 'react';
import { getConfiguration, getConfigurationSync } from '@sas/nova-core/config';
const subscribe = onStoreChange => {
  getConfiguration().then(() => {
    onStoreChange();
  });
  return () => {};
};
const getSnapshot = () => {
  return getConfigurationSync();
};
export const useConfig = function () {
  return useSyncExternalStore(subscribe, getSnapshot);
};
//# sourceMappingURL=useConfig.js.map